import { render } from "./AlternativesKanbanPage.vue?vue&type=template&id=a2456dd4&scoped=true&ts=true"
import script from "./AlternativesKanbanPage.vue?vue&type=script&lang=ts"
export * from "./AlternativesKanbanPage.vue?vue&type=script&lang=ts"

import "./AlternativesKanbanPage.vue?vue&type=style&index=0&id=a2456dd4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2456dd4"]])

export default __exports__